import type {Rec} from 'typings/portaro.be.types';
import {FOND_PROJECT} from 'src/features/erp-sutor/sutor-fonds';
import {
    getFirstViewableFieldByFieldTypeIdRecursive,
    getTextFromViewableField
} from 'src/features/erp-sutor/sutor-utils';

export function getFormattedProjectNameParts(record: Rec): {name: string; projectNumber: string | null} {
    const projectNameField = getFirstViewableFieldByFieldTypeIdRecursive(record, FOND_PROJECT.projectNameFieldId);
    const projectNumberField = getFirstViewableFieldByFieldTypeIdRecursive(record, FOND_PROJECT.projectNumberFieldId);

    const projectName = getTextFromViewableField(projectNameField, null) ?? record.name;
    const projectNumber = getTextFromViewableField(projectNumberField, null);

    return {name: projectName, projectNumber};
}